import React, { useEffect, useMemo, useState } from "react";

import {

  ArrowLeft,

  Plus,

  Search,

  X,

} from "lucide-react";

import I from "../component/Icon";

import apiService from "../services/apiService";



const GET_ALL_USERS_API =

  "User/getAllUser?includeInActive=false";



const GET_ALL_USER_ROLES_API =

  "UserRole/getAllUserRoles?includeInActive=true";



const ADD_USER_ROLE_MAPPING_API =

  "UserRoleMapping/addUserRoleMapping";



const GET_PAGINATED_USER_ROLE_MAPPINGS_API =

  "UserRoleMapping/getPaginatedUserRoleMappings";



const DELETE_USER_ROLE_MAPPING_API =

  "UserRoleMapping/deleteUserRoleMapping";



const UPDATE_USER_ROLE_MAPPING_API =

  "UserRoleMapping/updateUserRoleMapping";



const getAuthToken = () => {

  const directKeys = [

    "token",

    "accessToken",

    "authToken",

    "jwtToken",

    "jwt",

  ];



  const cleanToken = (value) => {

    if (!value) return "";



    return String(value)

      .replace(/^"|"$/g, "")

      .replace(/^Bearer\s+/i, "")

      .trim();

  };



  const findTokenInObject = (value) => {

    if (!value || typeof value !== "object") {

      return "";

    }



    for (const key of directKeys) {

      const tokenValue =

        value?.[key] ??

        value?.[

          key.charAt(0).toUpperCase() +

            key.slice(1)

        ];



      if (tokenValue) {

        return cleanToken(tokenValue);

      }

    }



    return "";

  };



  const readStorage = (storage) => {

    for (const key of directKeys) {

      const value = storage.getItem(key);



      if (value) {

        return cleanToken(value);

      }

    }



    for (

      let index = 0;

      index < storage.length;

      index += 1

    ) {

      const key = storage.key(index);



      if (!key) continue;



      const rawValue =

        storage.getItem(key);



      if (!rawValue) continue;



      try {

        const parsed =

          JSON.parse(rawValue);



        const token =

          findTokenInObject(parsed);



        if (token) {

          return token;

        }

      } catch {

        const cleaned =

          cleanToken(rawValue);



        if (

          cleaned.split(".").length === 3

        ) {

          return cleaned;

        }

      }

    }



    return "";

  };



  const localToken =

    readStorage(localStorage);



  if (localToken) {

    return localToken;

  }



  const sessionToken =

    readStorage(sessionStorage);



  if (sessionToken) {

    return sessionToken;

  }



  const cookieToken =

    document.cookie

      .split(";")

      .map((item) => item.trim())

      .map((item) => {

        const separatorIndex =

          item.indexOf("=");



        if (separatorIndex === -1) {

          return ["", ""];

        }



        return [

          item.slice(0, separatorIndex),

          decodeURIComponent(

            item.slice(separatorIndex + 1)

          ),

        ];

      })

      .find(([key]) =>

        directKeys.includes(key)

      );



  return cleanToken(

    cookieToken?.[1] ?? ""

  );

};



const getLoggedInUserId = () => {

  const getIdFromObject = (value) => {

    if (!value || typeof value !== "object") {

      return 0;

    }



    return Number(

      value?.userId ??

      value?.UserId ??

      value?.id ??

      value?.Id ??

      value?.[

        "http\://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"

      ] ??

      value?.nameid ??

      value?.sub ??

      0

    );

  };



  const storageValues = [

    sessionStorage.getItem("user"),

    localStorage.getItem("user"),

  ];



  for (const value of storageValues) {

    if (!value) continue;



    try {

      const parsed = JSON.parse(value);

      const id = getIdFromObject(parsed);



      if (id && !Number.isNaN(id)) {

        return id;

      }

    } catch {

      // Keep existing flow unchanged if stored user data is not JSON.

    }

  }



  const token = getAuthToken();



  if (!token) {

    return 0;

  }



  try {

    const payloadPart =

      token.split(".")[1];



    if (!payloadPart) {

      return 0;

    }



    const normalizedPayload =

      payloadPart

        .replace(/-/g, "+")

        .replace(/_/g, "/");



    const paddedPayload =

      normalizedPayload.padEnd(

        normalizedPayload.length +

          ((4 - (normalizedPayload.length % 4)) % 4),

        "="

      );



    const payload =

      JSON.parse(

        decodeURIComponent(

          Array.from(

            atob(paddedPayload)

          )

            .map(

              (character) =>

                "%" +

                character

                  .charCodeAt(0)

                  .toString(16)

                  .padStart(2, "0")

            )

            .join("")

        )

      );



    const id =

      getIdFromObject(payload);



    return id && !Number.isNaN(id)

      ? id

      : 0;



  } catch (error) {

    console.error(

      "Failed to read UserId from login token:",

      error

    );



    return 0;

  }

};



const INITIAL_MAPPINGS = [];



const PAGE_SIZE = 10;



export default function UserRoleMappingPage() {

  const [mappings, setMappings] =

    useState(INITIAL_MAPPINGS);



  const [users, setUsers] = useState([]);

  const [usersLoading, setUsersLoading] = useState(false);



  const [roles, setRoles] = useState([]);

  const [rolesLoading, setRolesLoading] = useState(false);



  const [search, setSearch] = useState("");



  const [pageNumber, setPageNumber] = useState(1);

  const [totalRecords, setTotalRecords] = useState(0);



  const [modalOpen, setModalOpen] = useState(false);



  const [editing, setEditing] = useState(null);



  const [form, setForm] = useState({

    user: "",

    role: "",

    active: true,

  });



  const [selectedView, setSelectedView] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);



  /* ================= NOTIFICATION ================= */



  const [notification, setNotification] = useState(null);



  const showNotification = (type, message) => {

    setNotification({

      type,

      message,

    });

  };



  useEffect(() => {

    if (!notification) return;



    const timer = setTimeout(() => {

      setNotification(null);

    }, 3000);



    return () => clearTimeout(timer);

  }, [notification]);





  /* ================= GET ALL ACTIVE USERS ================= */



  useEffect(() => {

    const loadUsers = async () => {

      try {

        setUsersLoading(true);



        const response =

          await apiService.get(

            GET_ALL_USERS_API

          );



        const result =

          response.data;



        console.log(

          "Get All Users Response:",

          result

        );



        const output =

          result?.output ??

          result?.Output ??

          result?.data ??

          result?.Data ??

          result;



        const userResult =

          Array.isArray(output)

            ? output

            : Array.isArray(output?.result)

            ? output.result

            : Array.isArray(output?.Result)

            ? output.Result

            : Array.isArray(output?.data)

            ? output.data

            : Array.isArray(output?.Data)

            ? output.Data

            : [];



        const activeUsers =

          userResult

            .filter((user) => {

              const activeValue =

                user?.isActive ??

                user?.IsActive ??

                user?.active ??

                user?.Active ??

                false;



              return (

                activeValue === true ||

                Number(activeValue) === 1 ||

                String(activeValue).toLowerCase() === "true"

              );

            })

            .map((user) => ({

              ...user,



              userName:

                user?.FullName ??

                user?.FullName ??

                user?.fullname ??

                user?.fullName ??

                "",

            }))

            .filter((user) => user.userName);



        setUsers(activeUsers);



      } catch (error) {

        console.error(

          "Get All Users API Error:",

          error

        );



        setUsers([]);

      } finally {

        setUsersLoading(false);

      }

    };



    loadUsers();

  }, []);





  /* ================= GET ALL USER ROLES ================= */



  useEffect(() => {

    const loadRoles = async () => {

      try {

        setRolesLoading(true);



        const response =

          await apiService.get(

            GET_ALL_USER_ROLES_API

          );



        const result =

          response.data;



        console.log(

          "Get All User Roles Response:",

          result

        );



        const output =

          result?.output ??

          result?.Output ??

          result?.data ??

          result?.Data ??

          result;



        const roleResult =

          Array.isArray(output)

            ? output

            : Array.isArray(output?.result)

            ? output.result

            : Array.isArray(output?.Result)

            ? output.Result

            : Array.isArray(output?.data)

            ? output.data

            : Array.isArray(output?.Data)

            ? output.Data

            : [];



        const normalizedRoles =

          roleResult

            .map((role) => ({

              ...role,



              id:

                role?.id ??

                role?.Id ??

                role?.userRoleId ??

                role?.UserRoleId,



              name:

                role?.roleName ??

                role?.RoleName ??

                role?.name ??

                role?.Name ??

                "",

            }))

            .filter((role) => role.name);



        setRoles(normalizedRoles);



      } catch (error) {

        console.error(

          "Get All User Roles API Error:",

          error

        );



        setRoles([]);

      } finally {

        setRolesLoading(false);

      }

    };



    loadRoles();

  }, []);





  /* ================= GET PAGINATED USER ROLE MAPPINGS ================= */



  const loadMappings = async (

    currentPage = pageNumber,

    searchValue = search

  ) => {

    try {

      const userId =

        getLoggedInUserId();



      const requestBody = {

        Page: currentPage,

        PageSize: PAGE_SIZE,

        SearchTerm: searchValue.trim(),

        SortDirection: "DESC",

        SortField: "Id",

        UserId: userId,

      };



      console.log(

        "Get Paginated User Role Mappings Request:",

        requestBody

      );



      const response =

        await apiService.post(

          GET_PAGINATED_USER_ROLE_MAPPINGS_API,

          requestBody

        );



      const result =

        response.data;



      console.log(

        "Get Paginated User Role Mappings Response:",

        result

      );



      const output =

        result?.output ??

        result?.Output ??

        result?.data ??

        result?.Data ??

        result;



      const mappingResult =

        Array.isArray(output)

          ? output

          : Array.isArray(output?.result)

          ? output.result

          : Array.isArray(output?.Result)

          ? output.Result

          : Array.isArray(output?.data)

          ? output.data

          : Array.isArray(output?.Data)

          ? output.Data

          : [];



      const normalizedMappings =

        mappingResult.map((mapping, index) => {

          const userId =

            mapping?.userId ??

            mapping?.UserId ??

            mapping?.userid ??

            mapping?.Userid;



          const roleId =

            mapping?.roleId ??

            mapping?.RoleId ??

            mapping?.roleid ??

            mapping?.Roleid;



          const activeValue =

            mapping?.isActive ??

            mapping?.IsActive ??

            mapping?.active ??

            mapping?.Active ??

            false;



          const userName =

            mapping?.userName ??

            mapping?.UserName ??

            mapping?.fullName ??

            mapping?.FullName ??

            mapping?.name ??

            mapping?.Name ??

            users.find(

              (user) =>

                Number(

                  user?.id ??

                  user?.Id

                ) === Number(userId)

            )?.userName ??

            "";



          const roleName =

            mapping?.roleName ??

            mapping?.RoleName ??

            mapping?.userRoleName ??

            mapping?.UserRoleName ??

            roles.find(

              (role) =>

                Number(

                  role?.id ??

                  role?.Id ??

                  role?.userRoleId ??

                  role?.UserRoleId

                ) === Number(roleId)

            )?.name ??

            "";



          const backendId =

            mapping?.id ??

            mapping?.Id ??

            mapping?.userRoleMappingId ??

            mapping?.UserRoleMappingId;



          const displayId =

            (currentPage - 1) *

              PAGE_SIZE +

            index +

            1;



          return {

            ...mapping,



            backendId,

            id: displayId,

            displayId,



            userId,

            roleId,

            user: userName,

            role: roleName,



            active:

              activeValue === true ||

              Number(activeValue) === 1 ||

              String(activeValue).toLowerCase() === "true",

          };

        });



      const rowCountValue =

        output?.rowCount ??

        output?.RowCount ??

        output?.totalRecords ??

        output?.TotalRecords ??

        result?.rowCount ??

        result?.RowCount ??

        result?.totalRecords ??

        result?.TotalRecords ??

        normalizedMappings.length;



      const visibleMappings =

        normalizedMappings.filter(

          (mapping) => mapping.active

        );



      setMappings(visibleMappings);

      setTotalRecords(Math.max(0, Number(rowCountValue) || 0));



    } catch (error) {

      console.error(

        "Get Paginated User Role Mappings API Error:",

        error

      );



      setMappings([]);

      setTotalRecords(0);

    }

  };



  useEffect(() => {

    if (

      users.length > 0 &&

      roles.length > 0

    ) {

      loadMappings(

        pageNumber,

        search

      );

    }

  }, [pageNumber, search, users, roles]);





  const rows = useMemo(

    () => mappings,

    [mappings]

  );





  /* ================= PAGINATION ================= */



  const totalPages = Math.max(

    1,

    Math.ceil(totalRecords / PAGE_SIZE)

  );



  const pageNumbers = Array.from(

    { length: totalPages },

    (_, index) => index + 1

  );



  const paginatedRows = useMemo(

    () => rows,

    [rows]

  );



  useEffect(() => {

    setPageNumber(1);

  }, [search]);



  useEffect(() => {

    if (pageNumber > totalPages) {

      setPageNumber(totalPages);

    }

  }, [pageNumber, totalPages]);



  const openAdd = () => {

    setEditing(null);



    setForm({

      user: "",

      role: "",

      active: true,

    });



    setNotification(null);

    setModalOpen(true);

  };



  const openEdit = (row) => {

    setEditing(row);



    setForm({

      user: row.user,

      role: row.role,

      active: row.active,

    });



    setNotification(null);

    setModalOpen(true);

  };



  const save = async (event) => {

    event.preventDefault();



    if (!form.user || !form.role) {

      showNotification(

        "error",

        "Please select User and Role."

      );

      return;

    }



    if (editing) {

      try {

        const selectedUser =

          users.find(

            (user) =>

              user.userName === form.user

          );



        const selectedRole =

          roles.find(

            (role) =>

              role.name === form.role

          );



        const mappingId = Number(

          editing?.backendId ??

          editing?.BackendId

        );



        const userId = Number(

          selectedUser?.id ??

          selectedUser?.Id

        );



        const roleId = Number(

          selectedRole?.id ??

          selectedRole?.Id ??

          selectedRole?.userRoleId ??

          selectedRole?.UserRoleId

        );



        if (

          !mappingId ||

          Number.isNaN(mappingId) ||

          !userId ||

          Number.isNaN(userId) ||

          !roleId ||

          Number.isNaN(roleId)

        ) {

          showNotification(

            "error",

            "Invalid User Role Mapping, User or Role Id."

          );

          return;

        }



        const apiPayload = {

          Id: mappingId,

          userId: userId,

          roleId: roleId,

          IsActive: form.active,

        };



        console.log(

          "Update User Role Mapping Request:",

          apiPayload

        );



        const response =

          await apiService.put(

            UPDATE_USER_ROLE_MAPPING_API,

            apiPayload

          );



        console.log(

          "Update User Role Mapping Status:",

          response.status

        );



        console.log(

          "Update User Role Mapping Response:",

          response.data

        );



        await loadMappings(

          pageNumber,

          search

        );



        setModalOpen(false);

        setEditing(null);



        showNotification(

          "success",

          "User role mapping updated successfully."

        );



      } catch (error) {

        console.error(

          "Update User Role Mapping API Error:",

          error

        );



        showNotification(

          "error",

          error?.response?.data?.failureReason ||

          error?.response?.data?.FailureReason ||

          error?.response?.data?.message ||

          error?.response?.data?.Message ||

          error?.message ||

          "Failed to update user role mapping"

        );

      }



      return;

    }



    /* ================= ADD USER ROLE MAPPING - BACKEND API ================= */



    try {

      const selectedUser =

        users.find(

          (user) =>

            user.userName === form.user

        );



      const selectedRole =

        roles.find(

          (role) =>

            role.name === form.role

        );



      const userId = Number(

        selectedUser?.id ??

        selectedUser?.Id

      );



      const roleId = Number(

        selectedRole?.id ??

        selectedRole?.Id ??

        selectedRole?.userRoleId ??

        selectedRole?.UserRoleId

      );



      if (

        !userId ||

        Number.isNaN(userId) ||

        !roleId ||

        Number.isNaN(roleId)

      ) {

        showNotification(

          "error",

          "Invalid User or Role Id."

        );

        return;

      }



      const apiPayload = {

        userId: userId,

        roleId: roleId,

        IsActive: form.active,

      };



      console.log(

        "Add User Role Mapping Request:",

        apiPayload

      );



      const response =

        await apiService.post(

          ADD_USER_ROLE_MAPPING_API,

          apiPayload

        );



      console.log(

        "Add User Role Mapping Status:",

        response.status

      );



      console.log(

        "Add User Role Mapping Response:",

        response.data

      );



      await loadMappings(

        pageNumber,

        search

      );



      setModalOpen(false);

      setEditing(null);



      showNotification(

        "success",

        "User role mapping added successfully."

      );



    } catch (error) {

      console.error(

        "Add User Role Mapping API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to add user role mapping"

      );

    }

  };



  const confirmDelete = async () => {

    if (!deleteTarget) return;



    const mappingId = Number(

      deleteTarget?.backendId ??

      deleteTarget?.BackendId

    );



    if (

      !mappingId ||

      Number.isNaN(mappingId)

    ) {

      showNotification(

        "error",

        "Invalid User Role Mapping Id."

      );

      return;

    }



    try {

      console.log(

        "Delete User Role Mapping Id:",

        mappingId

      );



      const response =

        await apiService.delete(

          `${DELETE_USER_ROLE_MAPPING_API}/${mappingId}`

        );



      console.log(

        "Delete User Role Mapping Status:",

        response.status

      );



      console.log(

        "Delete User Role Mapping Response:",

        response.data

      );



      setMappings((prev) =>

        prev.filter(

          (mapping) =>

            Number(

              mapping?.backendId ??

              mapping?.BackendId

            ) !== mappingId

        )

      );



      setTotalRecords((prev) =>

        Math.max(

          0,

          Number(prev) - 1

        )

      );



      setDeleteTarget(null);



      showNotification(

        "success",

        "User role mapping deleted successfully."

      );



    } catch (error) {

      console.error(

        "Delete User Role Mapping API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to delete user role mapping"

      );

    }

  };



  /* ================= VIEW PAGE ================= */



  if (selectedView) {

    return (

      <div className="um-page">



        <div className="um-card">



          <div className="um-card-head">



            <h2>View User Role Mapping</h2>



            <button

              className="um-primary-btn"

              onClick={() => setSelectedView(null)}

            >

              <ArrowLeft size={17} />

              Back

            </button>



          </div>



          <div className="um-modal-body">



            <div className="um-grid-2">



              <label className="um-field">

                <span>Id</span>

                <input

                  value={selectedView.id}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>User Name</span>

                <input

                  value={selectedView.user}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Role Name</span>

                <input

                  value={selectedView.role}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Active</span>

                <input

                  value={

                    selectedView.active ? "Yes" : "No"

                  }

                  readOnly

                />

              </label>



            </div>



          </div>



        </div>



      </div>

    );

  }



  return (

    <div className="um-page">
      <style>{`
        .um-page { min-width:0; max-width:100%; }
        .um-page .um-card { min-width:0; max-width:100%; }
        .um-page .pagination-footer { width:100% !important; max-width:100% !important; min-width:0 !important; flex-wrap:wrap !important; overflow:hidden !important; }
        .um-page .pagination-bar { display:flex !important; align-items:center !important; flex:1 1 320px !important; min-width:0 !important; max-width:100% !important; gap:5px !important; overflow:hidden !important; justify-content:flex-end !important; }
        .um-page .pagination-bar > button { flex:0 0 auto !important; }
        .um-page .pagination-numbers { display:flex !important; align-items:center !important; min-width:0 !important; flex:0 1 auto !important; max-width:100% !important; overflow-x:auto !important; overflow-y:hidden !important; white-space:nowrap !important; scrollbar-width:thin; -webkit-overflow-scrolling:touch; overscroll-behavior-x:contain; }
        .um-page .pagination-numbers > button { flex:0 0 auto !important; }
        @media (max-width:768px) {
          .um-page .pagination-footer { flex-direction:column !important; align-items:stretch !important; gap:9px !important; }
          .um-page .pagination-bar { flex:0 0 auto !important; width:100% !important; justify-content:space-between !important; }
          .um-page .pagination-numbers { flex:1 1 0 !important; max-width:none !important; }
          .um-page .pagination-bar > button { min-width:51px !important; padding:0 7px !important; font-size:10px !important; }
          .um-page .pagination-numbers > button { min-width:30px !important; padding:0 7px !important; }
        }
      `}</style>




      {/* ================= NOTIFICATION ================= */}



      {notification && (

        <div

          style={{

            position: "fixed",

            top: "20px",

            right: "20px",

            zIndex: 99999,

            minWidth: "280px",

            maxWidth: "420px",

            padding: "12px 16px",

            borderRadius: "8px",

            backgroundColor:

              notification.type === "success"

                ? "#d1e7dd"

                : "#f8d7da",

            color:

              notification.type === "success"

                ? "#0f5132"

                : "#842029",

            border:

              notification.type === "success"

                ? "1px solid #badbcc"

                : "1px solid #f5c2c7",

            fontSize: "14px",

            fontWeight: 600,

            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",

          }}

        >

          {notification.type === "success" ? "✓ " : "✕ "}

          {notification.message}

        </div>

      )}



      <div className="um-card">



        <div className="um-card-head">



          <h2>User Role Mapping List</h2>



          <div className="um-head-actions">



            <button

              className="um-primary-btn"

              onClick={openAdd}

            >

              <Plus size={17} />

              Add New User Role Mapping

            </button>



            <label className="um-search">

              <Search size={17} />



              <input

                value={search}

                onChange={(e) => setSearch(e.target.value)}

                placeholder="Search..."

              />

            </label>



          </div>



        </div>



        <div className="um-table-wrap">



          <table className="um-table">



            <thead>

              <tr>

                <th>Id</th>

                <th>User Name</th>

                <th>Role Name</th>

                <th>Active</th>

                <th>Actions</th>

              </tr>

            </thead>



            <tbody>



              {paginatedRows.map((row) => (



                <tr key={row.id}>



                  <td>{row.id}</td>

                  <td>{row.user}</td>

                  <td>{row.role}</td>

                  <td>{row.active ? "Yes" : "No"}</td>



                  <td>

                    <div className="ra">



                      <button

                        type="button"

                        className="btn btn-p btn-sm"

                        title="View"

                        onClick={() => setSelectedView(row)}

                      >

                        <I

                          n="eye"

                          s={11}

                          c="#fff"

                        />

                      </button>



                      <button

                        type="button"

                        className="btn btn-g btn-sm"

                        title="Edit"

                        onClick={() => openEdit(row)}

                      >

                        <I

                          n="edit"

                          s={11}

                        />

                      </button>



                      <button

                        type="button"

                        className="btn btn-d btn-sm"

                        title="Delete"

                        onClick={() => setDeleteTarget(row)}

                      >

                        <I

                          n="trash"

                          s={11}

                        />

                      </button>



                    </div>

                  </td>



                </tr>



              ))}



            </tbody>



          </table>



        </div>



        {/* =====================================================

            PAGINATION - SAME UI AS SCHOOL PAGE

        ===================================================== */}



        {totalRecords > 0 && (

          <div className="pagination-footer"

            style={{

              width: "100%",

              display: "flex",

              alignItems: "center",

              justifyContent: "space-between",

              gap: "16px",

              marginTop: "16px",

              padding: "12px 4px 4px",

              borderTop: "1px solid #eef2f7",

            }}

          >

            {/* LEFT SIDE - SHOWING COUNT */}



            <div

              style={{

                display: "flex",

                alignItems: "center",

                whiteSpace: "nowrap",

                fontSize: "11px",

                lineHeight: "16px",

                color: "var(--t3)",

              }}

            >

              Showing{" "}



              <span

                style={{

                  margin: "0 4px",

                  fontWeight: 600,

                  color: "var(--t2)",

                }}

              >

                {(pageNumber - 1) * PAGE_SIZE + 1}

              </span>



              –



              <span

                style={{

                  margin: "0 4px",

                  fontWeight: 600,

                  color: "var(--t2)",

                }}

              >

                {Math.min(

                  pageNumber * PAGE_SIZE,

                  totalRecords

                )}

              </span>



              {" "}of{" "}



              <span

                style={{

                  marginLeft: "4px",

                  fontWeight: 600,

                  color: "var(--t2)",

                }}

              >

                {totalRecords}

              </span>

            </div>



            {/* RIGHT SIDE - PAGINATION */}



            <div className="pagination-bar"

              style={{

                display: "flex",

                alignItems: "center",

                gap: "5px",

              }}

            >

              {/* BACK BUTTON */}



              <button

                type="button"

                disabled={pageNumber === 1}

                onClick={() =>

                  setPageNumber((previous) =>

                    Math.max(1, previous - 1)

                  )

                }

                style={{

                  height: "32px",

                  minWidth: "66px",

                  padding: "0 10px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "3px",

                  border: "1px solid #e2e8f0",

                  borderRadius: "6px",

                  background:

                    pageNumber === 1

                      ? "#f8fafc"

                      : "#fff",

                  color:

                    pageNumber === 1

                      ? "#cbd5e1"

                      : "#475569",

                  fontSize: "11px",

                  fontWeight: 500,

                  cursor:

                    pageNumber === 1

                      ? "not-allowed"

                      : "pointer",

                  transition: "all 0.15s ease",

                }}

              >

                <span

                  style={{

                    fontSize: "16px",

                    lineHeight: 1,

                  }}

                >

                  ‹

                </span>



                Back

              </button>



              {/* PAGE NUMBERS */}



              <div className="pagination-numbers"

                style={{

                  display: "flex",

                  alignItems: "center",

                  gap: "4px",

                }}

              >

                {pageNumbers.map((page) => (

                  <button

                    key={page}

                    type="button"

                    onClick={() =>

                      setPageNumber(page)

                    }

                    style={{

                      height: "32px",

                      minWidth: "32px",

                      padding: "0 9px",

                      display: "inline-flex",

                      alignItems: "center",

                      justifyContent: "center",

                      border:

                        pageNumber === page

                          ? "1px solid #2563eb"

                          : "1px solid #e2e8f0",

                      borderRadius: "6px",

                      background:

                        pageNumber === page

                          ? "#2563eb"

                          : "#fff",

                      color:

                        pageNumber === page

                          ? "#fff"

                          : "#475569",

                      fontSize: "11px",

                      fontWeight: 600,

                      cursor: "pointer",

                      transition: "all 0.15s ease",

                    }}

                  >

                    {page}

                  </button>

                ))}

              </div>



              {/* NEXT BUTTON */}



              <button

                type="button"

                disabled={pageNumber >= totalPages}

                onClick={() =>

                  setPageNumber((previous) =>

                    Math.min(

                      totalPages,

                      previous + 1

                    )

                  )

                }

                style={{

                  height: "32px",

                  minWidth: "66px",

                  padding: "0 10px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "3px",

                  border: "1px solid #e2e8f0",

                  borderRadius: "6px",

                  background:

                    pageNumber >= totalPages

                      ? "#f8fafc"

                      : "#fff",

                  color:

                    pageNumber >= totalPages

                      ? "#cbd5e1"

                      : "#475569",

                  fontSize: "11px",

                  fontWeight: 500,

                  cursor:

                    pageNumber >= totalPages

                      ? "not-allowed"

                      : "pointer",

                  transition: "all 0.15s ease",

                }}

              >

                Next



                <span

                  style={{

                    fontSize: "16px",

                    lineHeight: 1,

                  }}

                >

                  ›

                </span>

              </button>

            </div>

          </div>

        )}



      </div>



      {/* ADD / EDIT POPUP */}



      {modalOpen && (



        <div

          className="um-modal-backdrop"

          onMouseDown={() => setModalOpen(false)}

        >



          <form

            className="um-modal um-modal-role"

            onSubmit={save}

            onMouseDown={(e) => e.stopPropagation()}

          >



            <div className="um-modal-head">



              <h3>

                {editing

                  ? "Edit User Role Mapping"

                  : "Add New User Role Mapping"}

              </h3>



              <button

                type="button"

                className="um-close-btn"

                onClick={() => setModalOpen(false)}

              >

                <X size={20} />

              </button>



            </div>



            <div className="um-modal-body">



              <div className="um-grid-2">



                <label className="um-field">

                  <span>User</span>



                  <select

                    value={form.user}

                    onChange={(e) =>

                      setForm((prev) => ({

                        ...prev,

                        user: e.target.value,

                      }))

                    }

                  >

                    <option value="">

                      {usersLoading

                        ? "Loading Users..."

                        : "Select User"}

                    </option>



                    {users.map((user) => (

                      <option

                        key={

                          user?.id ??

                          user?.Id ??

                          user.userName

                        }

                        value={user.userName}

                      >

                        {user.userName}

                      </option>

                    ))}

                  </select>

                </label>



                <label className="um-field">

                  <span>Role</span>



                  <select

                    value={form.role}

                    disabled={rolesLoading}

                    onChange={(e) =>

                      setForm((prev) => ({

                        ...prev,

                        role: e.target.value,

                      }))

                    }

                  >

                    <option value="">

                      {rolesLoading

                        ? "Loading Roles..."

                        : "Select Role"}

                    </option>



                    {roles.map((role) => (

                      <option

                        key={

                          role?.id ??

                          role?.Id ??

                          role.name

                        }

                        value={role.name}

                      >

                        {role.name}

                      </option>

                    ))}

                  </select>

                </label>



              </div>



            </div>



            <div className="um-modal-foot">



              <button

                type="button"

                className="um-cancel-btn"

                onClick={() => setModalOpen(false)}

              >

                Cancel

              </button>



              <button

                className="um-primary-btn"

                type="submit"

              >

                {editing ? "Update" : "Add"}

              </button>



            </div>



          </form>



        </div>

      )}



      {/* DELETE POPUP */}



      {deleteTarget && (



        <div

          className="um-modal-backdrop"

          onMouseDown={() => setDeleteTarget(null)}

        >



          <div

            className="um-modal um-modal-role"

            onMouseDown={(e) => e.stopPropagation()}

          >



            <div className="um-modal-head">



              <h3>Delete User Role Mapping</h3>



              <button

                type="button"

                className="um-close-btn"

                onClick={() => setDeleteTarget(null)}

              >

                <X size={20} />

              </button>



            </div>



            <div className="um-modal-body">



              <p>

                Are you sure you want to delete mapping{" "}

                <strong>{deleteTarget.user}</strong> -{" "}

                <strong>{deleteTarget.role}</strong>?

              </p>



            </div>



            <div className="um-modal-foot">



              <button

                type="button"

                className="um-cancel-btn"

                onClick={() => setDeleteTarget(null)}

              >

                Cancel

              </button>



              <button

                type="button"

                className="um-primary-btn"

                onClick={confirmDelete}

              >

                Delete

              </button>



            </div>



          </div>



        </div>

      )}



    </div>

  );

}